import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEye,
  faEdit,
  faTrashCan,
  faEnvelopeOpen,
  faEnvelope,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

const Table = ({ columns, data, url, onDelete, onMarkSeen, actionsMenu, lastRowRef }) => {
  if(!data || data.length<1)return <h1>No data to display</h1>
  return (
    <>
      <table className="min-w-full border-collapse bg-white/40 text-left rounded-lg p-4 pt-0">
        <thead>
          <tr>
            {columns.map((col, idx) => (
              <th key={idx} className="px-4 py-2 capitalize">
                {col}
              </th>
            ))}
            <th className="px-4 py-2 capitalize"></th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, rowIndex) => {
            const isLastRow = rowIndex === data.length - 1;
            return (
              <tr
                className="odd:bg-gray-300 hover:bg-gray-100"
                key={rowIndex}
                ref={isLastRow ? lastRowRef : null}>
                {columns.map((col, colIndex) => (
                  <td key={colIndex} className={`${col !== "email"?"capitalize":"lowercase"} px-4 py-2`}>
                    {row[col]}
                  </td>
                ))}
                <td className="py-2 flex justify-between capitalize gap-1">
                  {actionsMenu?.markSeen && (
                    <button
                      className="px-2 py-1 text-white rounded-full capitalize">
                      {data[rowIndex].status === "seen" && (
                        <FontAwesomeIcon
                          icon={faEnvelopeOpen}
                          className="text-green-800 text-xl"
                        />
                      ) }
                      {data[rowIndex].status==='new' && <FontAwesomeIcon
                          icon={faEnvelope}
                          className="text-green-800 text-xl"
                          onClick={() => onMarkSeen(data[rowIndex])}
                        />
                      }
                    </button>
                  )}
                  <Link to={actionsMenu?.customViewLink?`${actionsMenu?.customViewLink}${data[rowIndex].owner?._id ||data[rowIndex]._id}` : `view${url}/${data[rowIndex]._id}`}>
                    {" "}
                    <button className="px-2 py-1 bg-blue-500 text-white  hover:bg-blue-600 rounded-full">
                      <FontAwesomeIcon icon={faEye} />
                    </button>
                  </Link>
                  {!actionsMenu?.edit && (
                    <Link to={actionsMenu?.customEditLink?`${actionsMenu?.customEditLink}${data[rowIndex]._id}` : `edit${url}/${data[rowIndex]._id}`}>
                      <button className="px-2 py-1 bg-green-500 text-white rounded-full hover:bg-green-600">
                        <FontAwesomeIcon icon={faEdit} />
                      </button>
                    </Link>
                  )}
                  {!actionsMenu?.delete && (
                    <button
                      onClick={() => onDelete(data[rowIndex])}
                      className="px-2 py-1 bg-red-500 hover:bg-red-600 text-white rounded-full">
                      <FontAwesomeIcon icon={faTrashCan} />
                    </button>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </>
  );
};

export default Table;
